module.exports = __webpack_public_path__ + "static/media/caterspot.945bd429.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/caterspot.jpg
// module id = 367
// module chunks = 0